import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { DecisionSwal } from "../../../../../../Utils/Utils/DecisionSwal";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { FormBultosSkim } from "./FormBultosSkim";
import { FormIdRecepcion } from "./FormIdRecepcion";
import { BultosTable } from "./BultosTable";
import { BultosSkimApi } from "../../../api/BultosSkimApi";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import { MostrarMensajeBultoSkimSinAnalisis } from "../utils/MensajesSwal";

export const DetalleBultosSkim = ({ regresar }) => {
    const bultosSkimApi = BultosSkimApi();
    const { getBultosSkim, descartarBultoSkim, getTotalesBultosSkim, cargando } =
        bultosSkimApi;

    const [bultos, setBultos] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);
    const [totales, setTotales] = useState({});

    const GetBultosSkim = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
                filtrar_disponibles: true,
            };

            const response = await getBultosSkim(params);
            setBultos(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener bultos skim",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setBultos([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        GetBultosSkim();
    }, [paginaSeleccionada]);

    const GetTotalesBultosSkim = async () => {
        try {
            const response = await getTotalesBultosSkim();
            setTotales(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los totales de bultos skim",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setTotales({});
        }
    };

    useEffect(() => {
        GetTotalesBultosSkim();
    }, []);

    const RefreshData = () => {
        GetBultosSkim();
        GetTotalesBultosSkim();
    };

    const DescartarBultoSkim = async (id) => {
        try {
            await descartarBultoSkim(id);
            NotificationManager.success(
                "Bulto skim descartado con éxito",
                "Éxito",
                3000,
            );
            RefreshData();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al descartar bulto skim",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const MostrarMensajeDescartarBultoSkim = (bulto) => {
        const fueUtilizado =
            parseFloat(bulto.kg_humedos_original) !==
            parseFloat(bulto.kg_humedos_actual);

        if (fueUtilizado && !bulto.drc) {
            MostrarMensajeBultoSkimSinAnalisis();
            return;
        }

        const mensaje =
            "¿Está seguro que desea descartar este bulto skim? Ya no estará disponible para su uso y esta acción no se podrá revertir.";

        DecisionSwal(mensaje, "Sí", "No", () => DescartarBultoSkim(bulto.id));
    };

    return (
        <LoadMask loading={cargando} blur>
            <CardEmpty noShadow>
                <FormBultosSkim
                    bultosSkimApi={bultosSkimApi}
                    RefreshData={RefreshData}
                />

                <FormIdRecepcion
                    bultosSkimApi={bultosSkimApi}
                    RefreshData={RefreshData}
                />

                <BultosTable
                    bultos={bultos}
                    DescartarBultoSkim={MostrarMensajeDescartarBultoSkim}
                    totales={totales}
                />

                <Paginacion
                    cantidadResultados={cantidadResultados}
                    paginaSeleccionada={paginaSeleccionada}
                    setPaginaSeleccionada={setPaginaSeleccionada}
                />

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={regresar}
                        disabled={cargando}
                    >
                        Regresar
                    </button>
                </div>
            </CardEmpty>
        </LoadMask>
    );
};
